
/**
 * This file contains legacy static slug redirects that TYT.com always performs slug navigation on.
 * This mechanism allows for a short URL (ie "/foo") to be served while allowing lazy load mechanics
 * based on URL to work. For instance, the user sees "/redeem" but within Angular we load "/billing/redeem"
 * Note that these are case-insensitive!
 */
export const STATIC_SLUGS: Record<string,string> = {
    live: '/live' // handles case sensitivity, this allows /LIVE, /Live, /LIve etc to work
};